import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaretCircleRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.0005 22.0002C17.5233 22.0002 22.0005 17.5231 22.0005 12.0002C22.0005 6.4774 17.5233 2.00024 12.0005 2.00024C6.47764 2.00024 2.00049 6.4774 2.00049 12.0002C2.00049 17.5231 6.47764 22.0002 12.0005 22.0002Z",
		fill: "#42296E"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.75 8.24976L14.9174 12.0004L10.75 15.751",
		stroke: "white",
		strokeWidth: 1.74369,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCaretCircleRight;
